import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer>
            <div className="inner">

                <div className="footer-content">
                    <p>{"Make By MoeMoe Company💖"}</p>
                </div>

            </div>
        </footer>
    );
}
export default Footer;
